export default "__VITE_ASSET__BDTjBYCA__"